module.exports = __webpack_public_path__ + "static/js-af21eb2288122b1fa10d70e061d550f4.png";